// extracted by mini-css-extract-plugin
module.exports = {"tabWrapper":"tabs-module--tab-wrapper--2Q3S7","tab":"tabs-module--tab--OJWFh","btn":"tabs-module--btn--2V1t6"};